import React, { useEffect, useState } from "react";

import Element from "../../components/Forms/Element";
import { RootViewElement } from "records/Element";
import { BaseElementProps } from "elements/types";
import Group from "./Group";
import { FormElements } from "lib/api/types";

export const useElementsGroups = (elements: FormElements) => {
	const [groups, setGroups] = useState<number[][]>([]);

	useEffect(() => {
		const newGroups: number[][] = [];
		let groupIndex = 0;
		for (let i = 0; i < elements.length; i++) {
			Array.isArray(newGroups[groupIndex])
				? newGroups[groupIndex].push(i)
				: (newGroups[groupIndex] = [i]);
			if (elements[i]?.elementLayout?.lineBreakAfterElement) {
				groupIndex++;
			}
		}
		setGroups(newGroups);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { groups };
};

function RootForm({
	fid,
	traversal,
	elements,
	formLayout,
}: BaseElementProps & RootViewElement) {
	const { groups } = useElementsGroups(elements);

	const MOBILE_WIDTH = 768;
	const [width, setWidth] = useState(window.innerWidth);
	const handleWindowSizeChange = () => setWidth(window.innerWidth);

	useEffect(() => {
		window.addEventListener("resize", handleWindowSizeChange);
		return () => {
			window.removeEventListener("resize", handleWindowSizeChange);
		};
	}, []);

	if (formLayout?.fullWidth && width >= MOBILE_WIDTH)
		return (
			<div className="view root-view d-flex">
				<Group
					groups={groups}
					elements={elements}
					traversal={traversal}
					fullWidth={formLayout?.fullWidth}
					fid={fid}
				/>
			</div>
		);

	return (
		<div className="view root-view">
			{traversal &&
				traversal.map(uuid => (
					<Element key={uuid} fid={fid} uuid={uuid} rowIndex={0} />
				))}
		</div>
	);
}

export default React.memo(RootForm);
